import {
  CATEGORY_NOT_UNIQUE_ERROR,
  EMPTY_CATEGORY,
  EMPTY_TERM,
  getTermNotUniqueError,
  TERM_SAME_COLOUR_ERROR,
} from "constants/dictionary";
import {
  getErrorMessage,
  isCategoryUnique,
  isTermColourValid,
  isTermUnique,
} from "utils/dictionary";

// If category is opened in edit mode, opens it in view mode too
export const syncCategories = (prevDictionary, newDictionary) => {
  if (prevDictionary.categories.length !== newDictionary.categories.length) {
    return prevDictionary;
  }

  return {
    ...prevDictionary,
    categories: prevDictionary.categories.map((category, index) => ({
      ...category,
      isExpanded: newDictionary.categories[index].isExpanded,
    })),
  };
};

export const validateCategory = (category, categories) => {
  const categoryErrors = [];

  // Category must have a name
  if (!category.name) {
    categoryErrors.push(EMPTY_CATEGORY);

    // If category name is missing, only message for this validation should be displayed, so other checks are skipped
    return {
      ...category,
      error: getErrorMessage(categoryErrors),
    };
  }

  // Category must be unique
  if (!isCategoryUnique(category, categories)) {
    categoryErrors.push(CATEGORY_NOT_UNIQUE_ERROR);
  }

  return {
    ...category,
    error: getErrorMessage(categoryErrors),
  };
};

export const validateDictionaryTerms = (category, categories) => {
  return category.terms.map((term) => {
    const termErrors = [];

    // Term must have a name
    if (!term.name) {
      termErrors.push(EMPTY_TERM);

      // If term name is missing, only message for this validation should be displayed, so other checks are skipped
      return {
        ...term,
        error: getErrorMessage(termErrors),
      };
    }

    // Term must be unique
    if (!isTermUnique(term, category.terms)) {
      termErrors.push(getTermNotUniqueError(term.name, category.name));
    }

    // Same terms from different categories can't have same colours(except default colour)
    if (!isTermColourValid(term, categories)) {
      termErrors.push(TERM_SAME_COLOUR_ERROR);
    }

    return {
      ...term,
      error: getErrorMessage(termErrors),
    };
  });
};

export const changeColour = (category, action) => {
  if (
    category.id === action.payload.categoryId &&
    action.payload.termId === undefined
  ) {
    return {
      ...category,
      colour: action.payload.colour,
      terms: category.terms.map((t) => ({
        ...t,
        colour: action.payload.colour,
      })),
    };
  }

  return {
    ...category,
    terms: category.terms.map((t) => {
      if (
        t.id === action.payload.termId &&
        t.categoryId === action.payload.categoryId
      ) {
        return { ...t, colour: action.payload.colour };
      }
      return t;
    }),
  };
};

export const getDictionaryName = (dictionaries) => {
  if (!dictionaries.find((d) => d.name === "New Dictionary")) {
    return "New Dictionary";
  }

  const matches = dictionaries.filter((d) =>
    d.name.match(/^New Dictionary \((\d*)\)$/)
  );

  if (matches.length === 0) {
    return "New Dictionary (1)";
  }

  const { name } = matches.sort()[matches.length - 1];
  const prevNumber = Number(name.match(/(\d+)/)[0]);
  return `New Dictionary (${prevNumber + 1})`;
};
